import React, { useState } from 'react';
import { FaBuilding, FaPhone, FaEnvelope, FaShieldAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzGg4T4dB4XRQKnQvrq_PUV8og-bqOtnElFIMABExYs6_NY5gS0cbmy0QYke_Qs7Cnw/exec";

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  const formBody = new URLSearchParams({
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    service: formData.service,
    message: formData.message,
  }).toString();

  try {
    await fetch(SCRIPT_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody,
    });

    alert("✅ Thank you! Your enquiry has been submitted.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      service: "",
      message: "",
    });
  } catch (error) {
    alert("❌ Sorry, there was an error submitting your form. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="section-header center animate-on-scroll">
          <span className="section-label">Get in Touch</span>
          <h2>Contact Us</h2>
        </div>

        <div className="contact-wrapper">
          <div className="contact-info">
            <div className="office-card animate-on-scroll">
              <h3><FaBuilding /> Head Office – Tuticorin</h3>
              <p>Tuticorin, Tamil Nadu – 628003</p>
              <p><FaPhone /> +91 0461 2322137</p>
            </div>
            <div className="office-card animate-on-scroll">
              <h3><FaBuilding /> Branch Office – Chennai</h3>
              <p>1st Floor, Sindur Plaza,<br />42 Montieth Road, Egmore,<br />Chennai – 600008</p>
              <p><FaPhone /> +91 044 4550 0861</p>
            </div>
            <div className="office-card animate-on-scroll">
              <h3><FaEnvelope /> Email</h3>
              <p><a href="mailto:contact@xavnxav.com">contact@xavnxav.com</a></p>
            </div>
            <div className="confidentiality-note animate-on-scroll">
              <p><FaShieldAlt /> We maintain strict confidentiality and adhere to the highest standards of professional ethics.</p>
            </div>
          </div>

          <div className="contact-form-wrapper animate-on-scroll">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone *</label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="service">Service Required *</label>
                <select id="service" name="service" value={formData.service} onChange={handleChange} required>
                  <option value="">Select a service</option>
                  <option value="Automation">Automation Solutions</option>
                  <option value="IT Audit & Security">IT Audit & Security</option>
                  <option value="Accounting Services">Accounting Services</option>
                  <option value="Data Analytics & BI">Data Analytics & BI</option>
                  <option value="Audit & Assurance">Audit & Assurance</option>
                  <option value="Tax Advisory">Tax Advisory</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required></textarea>
              </div>
              <button type="submit" className="btn-primary" disabled={isSubmitting}>
  {isSubmitting ? 'Sending...' : 'Send Message'}
</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
